<template>
  <div class="aiw2-welcome">
    <div class="msg">
      <strong>Welcome back</strong>
      <span>You have an AI Writer draft in progress{{ stepLabel ? ` · ${stepLabel}` : '' }}.</span>
    </div>
    <div class="actions">
      <button class="aiw2-btn aiw2-btn--ghost" @click="$emit('start-fresh')">Start fresh</button>
      <button class="aiw2-btn aiw2-btn--primary" @click="$emit('resume')">Resume</button>
    </div>
  </div>
</template>

<script>
import { STEP_LABELS } from "../constants";
export default {
  name: "AiwV2WelcomeBackBar",
  props: { currentStep: { type: String, default: "" } },
  computed: {
    stepLabel() {
      return STEP_LABELS[this.currentStep] || "";
    },
  },
};
</script>

<style scoped>
.aiw2-welcome {
  display: flex; align-items: center; justify-content: space-between;
  background: var(--pop-blue-tint, #e9f3ff);
  border: 1px solid var(--pop-blue-soft, #c7ddff);
  border-radius: var(--r, 8px);
  padding: 10px 16px; margin: 12px 18px 0;
  font-family: "Mulish", system-ui, sans-serif; font-size: 0.85rem;
}
.msg { display: flex; gap: 8px; align-items: center; color: var(--text-2, #014751); }
.actions { display: flex; gap: 8px; }
</style>
